import { useMemo } from "react";
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import type { Property } from "@shared/schema";
import { PROPERTY_REDIRECT_ONLY_TABS } from "@/lib/property-redirect-tabs";

interface BackToPropertyLinkProps {
  propertyId: string | number | null | undefined;
  tab?: string;
  className?: string;
}

export function BackToPropertyLink({ propertyId, tab, className }: BackToPropertyLinkProps) {
  const idNum = useMemo(() => {
    if (propertyId === null || propertyId === undefined || propertyId === "") return null;
    const n = Number(propertyId);
    return Number.isFinite(n) ? n : null;
  }, [propertyId]);

  const { data: property } = useQuery<Property>({
    queryKey: ["/api/app/properties", idNum],
    enabled: idNum != null,
  });

  if (idNum == null) return null;

  const safeTab = tab && !PROPERTY_REDIRECT_ONLY_TABS.has(tab) ? tab : undefined;
  const href = `/app/properties/${idNum}${safeTab ? `?tab=${safeTab}` : ""}`;
  const name = property?.name || property?.address || `property #${idNum}`;

  return (
    <Link
      href={href}
      className={
        className ||
        "inline-flex items-center gap-1 text-sm text-brand hover:underline mb-4"
      }
      data-testid="link-back-to-property"
    >
      <ArrowLeft className="h-4 w-4" />
      Back to {name}
    </Link>
  );
}

export default BackToPropertyLink;
